import styled from '@emotion/styled'
import { Training } from 'session-info/training'

const Container = styled.div`
	width: 100%;
	align-items: stretch;
	display: flex;
	flex-direction: column;
	height: 100%;

	beelday-chat {
		height: 100%;
	}
`

type ChatTraining = Pick<Training, 'id' | 'participants' | 'upperEchelon'>

/** Who can be messaged in a training's chat: its participants and trainer. */
export const chatMembers = (training: ChatTraining): string[] =>
	training.participants
		.map(participant => participant.email)
		.concat([training.upperEchelon.email])

type Props = {
	training: ChatTraining
}
export const Chat: React.FC<Props> = ({ training }) => {
	return (
		<Container>
			<beelday-chat
				trainingId={training.id}
				participantsEmails={chatMembers(training).toString()}
			/>
		</Container>
	)
}

export default Chat
